import React, { useEffect, useState } from "react";
import DataTable, { defaultThemes } from "react-data-table-component";
import { ApiGet, ApiPost, ApiPut, ApiDelete } from "../../../helpers/API/ApiData";
import { toast } from "react-toastify";
import { Modal, Button } from "react-bootstrap";
import Dialog from "@material-ui/core/Dialog";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import CreateIcon from "@material-ui/icons/Create";
import DeleteIcon from "@material-ui/icons/Delete";
import moment from "moment";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Email_Subscribe = () => {
  const [subscriptions, setSubscriptions] = useState([]);
  const [filteredSubscriptions, setFilteredSubscriptions] = useState([]);
  const [openCreate, setOpenCreate] = useState(false);
  const [email, setEmail] = useState("");
  const [rowId, setRowId] = useState(null);
  const [errorEmail, setErrorEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [status, setStatus] = useState(null);
  const [statusId, setStatusId] = useState(null);
  const [search, setSearch] = useState("");
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 1,
  });

  // Fetch subscriptions with pagination and search
  const getSubscriptions = async () => {
    setLoading(true);
    try {
      const query = new URLSearchParams({
        page: pagination.page,
        limit: pagination.limit,
        ...(search && { email: search }),
      }).toString();
      const res = await ApiGet(`contact/get-email-subscribe?${query}`);
console.log("resresresres",res)
    
      if (res?.data?.result === 0) {
        setSubscriptions(res?.data?.payload?.subscriptions);
        setFilteredSubscriptions(res?.data?.payload?.subscriptions);
        setPagination({
          ...pagination,
          total: res?.payload?.pagination?.total,
          totalPages: res?.payload?.pagination?.totalPages,
        });
      } else {
        toast.error(res.message || "Failed to fetch subscriptions.");
      }
    } catch (err) {
      toast.error("An error occurred while fetching subscriptions.");
      console.error("Fetch subscriptions error:", err);
    } finally {
      setLoading(false);
    }
  };

  // Handle search input
  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearch(value);
    setPagination({ ...pagination, page: 1 }); // Reset to first page on search
    // Client-side filtering as a fallback
    setFilteredSubscriptions(
      subscriptions.filter((item) =>
        item.email.toLowerCase().includes(value)
      )
    );
  };

  // Handle page change
  const handlePageChange = (newPage) => {
    setPagination({ ...pagination, page: newPage });
  };

  // Handle status change (active/deactive)
  const handleStatusChange = async () => {
    setLoading(true);
    try {
      const res = await ApiPut(
        `contact/update-email-subscribe`,
        { id: statusId, status: status },
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      if (res?.data?.result === 0) {
        toast.success(`Subscription ${status ? "activated" : "deactivated"} successfully.`);
        getSubscriptions();
      } else {
        toast.error(res.message || "Failed to update subscription status.");
      }
    } catch (err) {
      toast.error("An error occurred while updating subscription status.");
      console.error("Update status error:", err);
    } finally {
      setShowStatusModal(false);
      setLoading(false);
    }
  };

  // Handle unsubscribe
  const handleUnsubscribe = async (id, email) => {
    setLoading(true);
    try {
      const res = await ApiDelete(`/subscribe`, { email }, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      if (res.result === 0) {
        toast.success("Subscription unsubscribed successfully.");
        getSubscriptions();
      } else {
        toast.error(res.message || "Failed to unsubscribe.");
      }
    } catch (err) {
      toast.error("An error occurred while unsubscribing.");
      console.error("Unsubscribe error:", err);
    } finally {
      setLoading(false);
    }
  };

  // Handle add/update subscription
  const handleAddOrUpdateSubscription = async () => {
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setErrorEmail("Please enter a valid email address.");
      return;
    }

    setLoading(true);
    try {
      if (rowId) {
        // Update existing subscription
        const res = await ApiPut(
          `contact/update-email-subscribe`,
          { id: rowId, email },
          { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
        );


        console.log("resresrdddvfdesres",res)
        if (res?.data?.result === 0) {
          toast.success("Subscription updated successfully.");
          getSubscriptions();
          setOpenCreate(false);
          setEmail("");
          setRowId(null);
          setErrorEmail("");
        } else {
          toast.error(res.message || "Failed to update subscription.");
        }
      } else {
        // Add new subscription
        const res = await ApiPost(`/update-email-subscribe`, { email });
        console.log("resresrdddvfdesres",res)
        if (res?.data?.result === 0) {
          toast.success("Subscription added successfully.");
          getSubscriptions();
          setOpenCreate(false);
          setEmail("");
          setErrorEmail("");
        } else {
          toast.error(res.message || "Failed to subscribe. Please try again.");
        }
      }
    } catch (err) {
      toast.error("An error occurred. Please try again later.");
      console.error("Add/Update subscription error:", err);
    } finally {
      setLoading(false);
    }
  };

  // Open create/update dialog
  const handleClickOpen = (id, email) => {
    setRowId(id || null);
    setEmail(email || "");
    setErrorEmail("");
    setOpenCreate(true);
  };

  // Close create/update dialog
  const handleCloseCreate = () => {
    setOpenCreate(false);
    setEmail("");
    setRowId(null);
    setErrorEmail("");
  };

  // Open status change modal
  const handleStatusModal = (id, currentStatus) => {
    setStatusId(id);
    setStatus(!currentStatus);
    setShowStatusModal(true);
  };

  // Close status change modal
  const handleCloseStatusModal = () => {
    setShowStatusModal(false);
    setStatusId(null);
    setStatus(null);
  };

  // Fetch subscriptions on page or search change
  useEffect(() => {
    getSubscriptions();
  }, [pagination.page, pagination.limit, search]);

  // Table columns
  const columns = [
    {
      name: "S.No.",
      cell: (row, index) => (pagination.page - 1) * pagination.limit + index + 1,
      width: "80px",
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: "Status",
      cell: (row) => (row.status ? "Active" : "Inactive"),
      selector: (row) => row.status,
      sortable: true,
    },
    {
      name: "Created At",
      selector: (row) => row.createdAt,
      cell: (row) => moment(row.createdAt).format("MMM Do YYYY, h:mm a"),
      sortable: true,
    },
    {
      name: "Last Modified",
      selector: (row) => row.updatedAt,
      cell: (row) => moment(row.updatedAt).format("MMM Do YYYY, h:mm a"),
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="d-flex justify-content-between">
      
          <div
            className="cursor-pointer"
            onClick={() => handleUnsubscribe(row.id, row.email)}
          >
            <DeleteIcon />
          </div>
          {row.status ? (
            <Button
              onClick={() => handleStatusModal(row.id, row.status)}
              style={{
                backgroundColor: "red",
                border: "none",
                height: "35px",
                marginLeft: "10px",
              }}
            >
              Deactivate
            </Button>
          ) : (
            <Button
              onClick={() => handleStatusModal(row.id, row.status)}
              style={{
                border: "none",
                height: "35px",
                marginLeft: "10px",
                backgroundColor: "green",
              }}
            >
              Activate
            </Button>
          )}
        </div>
      ),
    },
  ];

  // Table styles
  const customStyles = {
    header: {
      style: {
        minHeight: "56px",
      },
    },
    headRow: {
      style: {
        borderTopStyle: "solid",
        borderTopWidth: "1px",
        borderTopColor: defaultThemes.default.divider.default,
      },
    },
    headCells: {
      style: {
        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
          borderRightColor: defaultThemes.default.divider.default,
        },
      },
    },
    cells: {
      style: {
        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
          borderRightColor: defaultThemes.default.divider.default,
        },
      },
    },
  };

  return (
    <>
      <div className="card p-1">
        <div className="p-2 mb-2">
          <div className="row mb-4">
            <div className="col d-flex justify-content-between">
              <h2 className="pl-3 pt-2">Subscription Management</h2>
              <button
                className="btn btn-primary"
                onClick={() => handleClickOpen()}
                disabled={loading}
              >
                Add Subscription
              </button>
            </div>
            <div className="col">
              <input
                type="text"
                className="form-control form-control-lg form-control-solid"
                placeholder="Search by email"
                value={search}
                onChange={handleSearch}
                disabled={loading}
              />
            </div>
          </div>
          <DataTable
            noHeader
            columns={columns}
            data={filteredSubscriptions}
            customStyles={customStyles}
            progressPending={loading}
            pagination
            paginationServer
            paginationTotalRows={pagination.total}
            paginationPerPage={pagination.limit}
            paginationRowsPerPageOptions={[10, 25, 50, 100]}
            onChangePage={(page) => handlePageChange(page)}
            onChangeRowsPerPage={(newLimit) =>
              setPagination({ ...pagination, limit: newLimit, page: 1 })
            }
          />
        </div>
      </div>

      <Modal show={showStatusModal} onHide={handleCloseStatusModal}>
        <Modal.Header closeButton>
          <Modal.Title className="text-danger">Confirm Action</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to {status ? "activate" : "deactivate"} this subscription?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseStatusModal}>
            Cancel
          </Button>
          <Button
            variant={status ? "success" : "danger"}
            onClick={handleStatusChange}
            disabled={loading}
          >
            {status ? "Activate" : "Deactivate"}
          </Button>
        </Modal.Footer>
      </Modal>

      <Dialog
        fullScreen
        open={openCreate}
        onClose={handleCloseCreate}
        TransitionComponent={Transition}
      >
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleCloseCreate}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
        <div className="form ml-30">
          <div className="form-group row">
            <label className="col-xl-3 col-lg-3 col-form-label">Email</label>
            <div className="col-lg-9 col-xl-6">
              <input
                type="email"
                className="form-control form-control-lg form-control-solid"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setErrorEmail("");
                }}
                placeholder="Enter email"
                disabled={loading}
              />
              {errorEmail && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {errorEmail}
                </span>
              )}
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-center">
            <button
              onClick={handleAddOrUpdateSubscription}
              className="btn btn-primary mr-2"
              disabled={loading}
            >
              <span>{rowId ? "Update" : "Add"} Subscription</span>
              {loading && <span className="mx-3 spinner spinner-white"></span>}
            </button>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default Email_Subscribe;